<div
  class="sol-tag-main"
  [class.sol-tag-main-with-icon]="!!icon$()"
  [class.sol-tag-main-with-children]="showChildren$()"
>
  @if (icon$()) {
    <sol-icon class="sol-tag-icon" [name]="icon$()" />
  }
  @if (hasText$()) {
    <div class="sol-tag-text">{{ text$() | translate }}</div>
  }
  @if (hasInfo$()) {
    <div class="sol-tag-info">{{ info$() | translate }}</div>
  }

  @if (showChildren$()) {
    <div class="sol-tag-children">
      @for (tag of childTags$(); track index; let index = $index) {
        <sol-tag [tag]="tag" (remove)="onChildRemove($event)" />
      }
    </div>
  }
</div>
@if (showRemove$()) {
  <button
    type="button"
    class="sol-tag-remove"
    [attr.aria-label]="
      hasText$() ? ('sol-tag.remove' | translate: { name: (text$() | translate) }) : ('sol-common.remove' | translate)
    "
    (click)="onRemove($event)"
  >
    <sol-icon class="sol-tag-remove-icon" size="12" [name]="SolIcon.remove" />
  </button>
}
